export type TColSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12; // TODO: seems css thingie, no need the type
export type TCenteredButtonProps = {
  label: string;
  type: string;
  disabled?: boolean;
  onClick?: (e: any) => void;
  loading?: boolean;
};

export type TProfileInputProps = {
  id: string;
  label: string | JSX.Element;
  type?: string;
  value: string | number | boolean | Date;
  handleChange: (e: any) => void;
  disabled: boolean;
};

export type TTableColumn = {
  id: string;
  label: string | JSX.Element;
  align?: "right" | "left" | "center";
  minWidth?: number;
  maxWidth?: number;
  width?: number;
  type?: string;
  linkTo?: string;
  format?: (value: string, row?: any) => JSX.Element; // formatting function for cell content (usually reduce display length)
  stylef?: (value: string, row?: any) => Object; // cell style function
  expandable?: boolean;
  expandedFormat?: (value: string, row?: any) => string; // formatting function for cell content when it is expanded
  tooltip?: string; // not implemented yet
};

export enum CheckedCorrect {
  CORRECT = "CORRECT",
  WRONG = "WRONG",
}

export type TChecked = {
  taskId: number;
  isCorrect: CheckedCorrect;
  hint: { note: string; image: string }[];
  hintImage?: string;
  rootId?: number;
  solutionImage?: string;
};

export type TCourse = {
  id: number;
  name: string;
  siteName: string;
  title: string;
  urlCode: string;
  text1?: string;
  text2?: string;
  text3?: string;
  text4?: string;
  header1: string;
  header2?: string;
  header3?: string;
  header4?: string;
  aTextBefore?: string;
  aTextAfter?: string;
  qTextBefore?: string;
  qTextAfter?: string;
  image?: string;
  base64CourseImage?: string;
};

export type TCourseThemes = {
  shortName: string | null;
  siteName: string | null;
  name: string;
  id: number | null;
  city: string | null;
  www: string | null;
  course: TCourse[];
  group: string;
};

export type TCreateCourse = {
  id: number;
  name: string;
  site_name: string;
  header1: string;
  taskCount: number;
};

export type TEditCourse = {
  id: number;
  twin: number;
  url_code: string;
  program_id: string;
  order: number;
  school_id: number;
  name: string;
  title: string;
  description: string;
  site_name: string;
  header1: string;
  header2: string;
  header3: string;
  header4: string;
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  a_text_before: string;
  a_text_after: string;
  comment: string;
  theme_type_id: number;
  image: string;
  active: number;
  tag_list: string;
  tag_task_list: string;
  type_form: number;
  type: number;
  verif_date: string;
  link: string;
  www: string;
  url_id: string;
  page_id: number;
  tmp_year: number;
  tmp_var: number;
};

export type TEditTask = {
  id: number;
  modDate?: string;
  modUser?: string;
  rootId?: number;
  urlCode?: string;
  question?: string;
  questionImage?: string;
  answer?: string;
  answerMask?: string;
  answerType?: string | null;
  solution?: string;
  solutionImage?: string;
  comment?: string;
  source?: number;
  year?: number;
  var?: number;
  img_src?: string;
  tagList1?: string;
  tagList2?: string;
  tagList3?: string;
};

export interface TIdForCTM {
  id: string | number;
}
export interface TAssignedCoursesTableType extends TIdForCTM {
  course_id: number;
  course_name: string;
  true_cnt: string;
  wrong_cnt: string;
  empty_cnt: string;
}

export interface TAnswersType extends TIdForCTM {
  course_id: string;
  site_name: string;
  task_id: string;
  task_num: string;
  subtask_num: string;
  answer_count: string;
  answer: string;
  success: string;
  question: string;
}

export interface THomeworkType extends TIdForCTM {
  user_id: number;
  course_id: number;
  course_data: string;
  answer_date: string;
  answer_count: string;
  success: string;
  user_answers: string;
  minimath_answer: string;
  task_num: string;
  subtask_num: string;
  order_task: string;
  task_id: string;
  type_a: string;
  question: string;
  solution: string;
  course_site_name: string;
  rgb: string;
}

export type TNotificationStateType = {
  resultType: "Success" | "Failure" | null;
  message: string | null;
};

export type TSchool = {
  id: number;
  shortName: string;
  name: string;
  city: string;
  www: string;
  siteName?: string;
};

export type TSchoolOutput = {
  group: string;
  items: TSchool[];
};

export type TTask = {
  id: number;
  name: string;
  rootId: number;
  answerType: string;
  answerMask: string;
  questionImage?: string;
  question: string;
  subj?: string; // ???? remove?
  isAlreadySolved: boolean;
  subTasks?: TTask[];
  displayIndex?: number;
};

export type TUserAuth = {
  id: number; // string is UUID for unregistered/not logged in
  role: string;
  email?: string;
  access?: string;
  iat?: number;
  exp?: number;
};

export type TAuth = {
  email: "";
  password: "";
};

export type TUserInfo = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  sysName: string;
  nickname: string;
  grade: number | null;
  role: string;
  balance: number;
  balanceTime: string | null;
};
